"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileSalesSupportItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _gatsby = require("gatsby");

var _FAMobileIcon = require("./FAMobileIcon");

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  link: {
    textDecoration: 'none',
    color: theme.workwaveBlue
  }
}));

const MobileSalesSupportItem = _ref => {
  let {
    link,
    close,
    index,
    handleModalClick
  } = _ref;

  const handleClick = (e, slug) => {
    e.preventDefault();
    (0, _gatsby.navigate)("/".concat(slug));
  };

  const classes = useStyles();
  return link.slug.current.indexOf('tel') > -1 ? /*#__PURE__*/_react.default.createElement("a", {
    href: link.slug.current,
    className: classes.link,
    style: {
      textDecoration: 'none',
      fontFamily: '"Poppins", "Roboto", sans-serif'
    },
    target: "_self",
    id: link.navId
  }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    key: index,
    onClick: close
  }, /*#__PURE__*/_react.default.createElement(_FAMobileIcon.FAMobileIcon, {
    item: link
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontSize: '1.2rem',
      fontWeight: 400,
      fontFamily: '"Poppins", "Roboto", sans-serif'
    }
  }, link.title))) : /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
    to: "/".concat(link.slug.current),
    className: classes.link,
    style: {
      textDecoration: 'none'
    },
    id: link.navId
  }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: classes.link,
    key: index,
    onClick: close
  }, /*#__PURE__*/_react.default.createElement(_FAMobileIcon.FAMobileIcon, {
    item: link
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontSize: '1.2rem',
      fontWeight: 400,
      fontFamily: '"Poppins", "Roboto", sans-serif'
    }
  }, link.title)));
};

exports.MobileSalesSupportItem = MobileSalesSupportItem;